export const THROUGH_APPOINTMENT_JOURNEY = 'treatment_note';
export const THROUGH_CUSTOMER_CARD = 'medical_note';
